import { useState } from 'react';
import { Placeholder } from 'rsuite';
import styled from 'styled-components';

interface IShow {
  show: boolean;
}

const FadeWrapper = styled.div<IShow>`
  animation-duration: 0.5s;
  animation-fill-mode: both;
  animation-name: ${(props) => (props.show ? 'unset' : 'fadeOut')};
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 9;
  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;

export const MapSkeleton = ({ show }: IShow) => {
  const [shouldRender, setRender] = useState(true);

  const onAnimationEnd = () => {
    if (!show) setRender(false);
  };

  if (!shouldRender) return <></>;

  return (
    <FadeWrapper show={show} onAnimationEnd={onAnimationEnd}>
      {/* @ts-expect-error Invalid type for props */}
      <Placeholder.Graph height="100%" width="100%" />
    </FadeWrapper>
  );
};
